import { config } from '../../../../../config';
import { IPrice } from '../IPrice';

const {
	currency: { locale, precision },
} = config;

export function getFormattedPrice(price: IPrice) {
	const formatter = new Intl.NumberFormat(locale, {
		style: 'currency',
		currency: price.currencyCode,
		maximumFractionDigits: precision,
		minimumFractionDigits: precision,
	});

	return formatter.format(price.decimalValue);
}
